import TipsOverview from './TipsOverview'

export default TipsOverview
